/* blocks */
import PageHero from '@/cmp/organism/PageHero/PageHero'
import CustomerLogo from '@/cmp/organism/CustomerLogo/CustomerLogo'
import Capabilities from './components/Capabilities/Capabilities'
import ValueOutcomes from '@/cmp/organism/ValueOutcomes/ValueOutcomes'
import RevenueEngine from '@/cmp/organism/RevenueEngine/RevenueEngine'
import Ecosystem from '@/cmp/organism/Ecosystem/Ecosystem'
import PepperGPTComparison from './components/PepperGPTComparison/PepperGPTComparison'
import FAQNew from '@/cmp/organism/FAQNew/FAQNew'
import FooterCta from '@/cmp/organism/FooterCta/FooterCta'

/* utils */
import { ProductGenAiPageAttributes } from '@/utils/queries/product/gen_ai'

interface Props {
  data: ProductGenAiPageAttributes
}

function GenAiTemplate({ data }: Props): JSX.Element {
  return (
    <>
      <PageHero
        primaryHeadline={data.hero.title}
        subText={data.hero.description}
        primaryCta={data.hero.primaryCta}
        secondaryCta={data.hero.secondaryCta}
        footNote={data.hero.footnote}
        image={data.hero.image?.data?.attributes}
      />

      {data.brands.brands.data.length > 0 ? (
        <CustomerLogo
          title={data.brands.title}
          brands={data.brands.brands.data.map(i => ({
            ...i.attributes.logo.data.attributes,
            alternativeText: i.attributes.name
          }))}
          awards={data.awardsList.data.map(item => ({
            url: item.attributes.url,
            alternativeText: item.attributes.alternativeText ?? '',
            width: item.attributes.width,
            height: item.attributes.height
          }))}
        />
      ) : null}

      {data.useCaseTabsList.length > 0 ? (
        <Capabilities
          title={data.useCaseTabsTitle}
          list={data.useCaseTabsList.map(item => ({
            title: item.title ?? '',
            image: item.multimedia?.media?.data?.attributes,
            color: item.color ?? '',
            tag: item.additionalFields?.tag as string | undefined
          }))}
        />
      ) : null}

      {data.goalList.length > 0 ? (
        <ValueOutcomes
          layout="descriptive"
          theme="light"
          title={data.goalTitle}
          list={data.goalList.map(i => ({
            id: i.id,
            title: i.title ?? '',
            description: i.description ?? '',
            borderColor: i.color,
            image: i.multimedia?.media?.data?.attributes
          }))}
        />
      ) : null}

      {data.revenueEngineList.length > 0 ? (
        <RevenueEngine
          title={data.revenueEngineTitle}
          lists={data.revenueEngineList.map(i => ({
            id: i.id,
            title: i.title ?? '',
            description: i.description ?? '',
            image: i.multimedia?.media?.data?.attributes
          }))}
        />
      ) : null}

      {data.contentEcosystem.multimedia?.media?.data?.attributes ? (
        <Ecosystem
          title={data.contentEcosystem.title ?? ''}
          description={data.contentEcosystem.description ?? ''}
          image={data.contentEcosystem.multimedia.media.data.attributes}
          cta={data.contentEcosystem.link}
        />
      ) : null}

      <PepperGPTComparison />

      {data.faqs.length > 0 ? (
        <FAQNew title={data.faqTitle} list={data.faqs} />
      ) : null}

      {data.footerCta.title ? (
        <FooterCta
          headline={data.footerCta.title}
          primaryCta={data.footerCta.primaryCta}
          mode="full_width"
        />
      ) : null}
    </>
  )
}

export default GenAiTemplate
